const createRequestVersion = () => {
  let currentRequest = null;

  return {
    begin() {
      currentRequest = Symbol("request");
      return currentRequest;
    },
    invalidate() {
      currentRequest = null;
    },
    isCurrent(request) {
      return request === currentRequest;
    },
  };
};

export { createRequestVersion };
